import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const latestMovies = movies.filter((m) => m.isNew).slice(0, 6);

export default function LatestUpdates() {
  return (
    <section className="py-10 md:py-14 bg-background-100" aria-label="最新上线">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，追剧不停</p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap transition-colors"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <div className="w-28 md:w-36 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 极速影视`}
                  className="w-full aspect-[3/4] object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-center min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate font-heading">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
                  {movie.description}
                </p>
                <div className="flex flex-wrap items-center gap-2 mt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-0.5 text-accent-500 font-medium">
                    <i className="ri-star-fill"></i>
                    {movie.rating}
                  </span>
                  <span>{movie.year}</span>
                  <span>{movie.subcategory}</span>
                </div>
                <div className="mt-2 text-xs text-primary-500 font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  立即观看
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}